var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFolderShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.89543 0.895431 0 2 0H8L10 2H18C19.1046 2 20 2.89543 20 4V14C20 15.1046 19.1046 16 18 16H2C0.895431 16 0 15.1046 0 14V2ZM16 6.5C16 7.88071 14.8807 9 13.5 9C12.1193 9 11 7.88071 11 6.5C11 5.11929 12.1193 4 13.5 4C14.8807 4 16 5.11929 16 6.5ZM13.5 10C15.75 10 18 11 18 12.5V14H9V12.5C9 11 11.25 10 13.5 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFolderShare);
export default __webpack_public_path__ + "static/media/ic_action_folder_share.a913e0189375d272f3d62e28e61af0ee.svg";
export { ForwardRef as ReactComponent };